module.exports = __webpack_public_path__ + "static/media/41_A.bbaa7098.png";